var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 263,
    viewBox: "0 0 305 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3408 263H305V53.625L79.3408 263Z",
    fill: "#CCE6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.945 67.7861H56.0647C51.3785 67.7861 47.5796 71.5819 47.5796 76.2643V238.932C47.5796 243.614 51.3785 247.41 56.0647 247.41H158.945C163.631 247.41 167.43 243.614 167.43 238.932V76.2643C167.43 71.5819 163.631 67.7861 158.945 67.7861Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8772 157.603C73.8772 176.161 88.9345 191.206 107.509 191.206C126.083 191.206 141.14 176.161 141.14 157.603C141.14 139.044 126.083 123.999 107.509 123.999C88.9345 123.999 73.8772 139.044 73.8772 157.603Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M158.945 67.7861H100.121V219.072C100.123 221.455 101.071 223.74 102.758 225.425C104.444 227.111 106.731 228.058 109.116 228.06H167.43V76.2643C167.426 74.017 166.531 71.8628 164.94 70.2737C163.35 68.6847 161.194 67.7902 158.945 67.7861Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.874 34.1826H115.994C111.307 34.1826 107.509 37.9784 107.509 42.6608V205.328C107.509 210.011 111.307 213.807 115.994 213.807H218.874C223.56 213.807 227.359 210.011 227.359 205.328V42.6608C227.359 37.9784 223.56 34.1826 218.874 34.1826Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.806 157.603H201.069V90.3953L133.806 90.3953V157.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.806 157.603H201.069V90.3953L133.806 90.3953V157.603Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M218.866 34.1826H160.042V185.453C160.046 187.837 160.996 190.122 162.684 191.807C164.372 193.492 166.659 194.439 169.045 194.441H227.351V42.6607C227.347 40.4135 226.452 38.2593 224.862 36.6702C223.271 35.0811 221.115 34.1867 218.866 34.1826Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.795 0.579102H175.915C171.229 0.579102 167.43 4.37489 167.43 9.05724V171.725C167.43 176.407 171.229 180.203 175.915 180.203H278.795C283.481 180.203 287.28 176.407 287.28 171.725V9.05724C287.28 4.37489 283.481 0.579102 278.795 0.579102Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.174 121.921L227.351 58.8604L262.536 121.921H192.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.174 121.921L227.351 58.8604L262.536 121.921H192.174Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1035,
    cy: 69.1035,
    r: 36.1035,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8921 78.146V74.766H28.9221V72.114L37.4501 59.946H41.2201V71.88H43.6121V74.766H41.2201V78.146H37.8921ZM32.4841 71.88H38.1001V63.612L32.4841 71.88Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 263,
    fill: "white",
    transform: "translate(47)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/Buy.02cf4eca1821031ce3e2a9e691d2fdf0.svg";
export { ForwardRef as ReactComponent };